<template>
  <div>
    <DxCheckBox
      :ref="'select-all-' + data.column.dataField"
      v-model="selectAll"
      @value-changed="selectAllItems"
      :id="id"
      class="select-all-class"
      :readOnly="baseView.mode == 'review' ? true : readOnly"
      @initialized="onInitialized"
      :value="checkBoxValue"
      :disabled="disabled"
    />
    <span class="template-header-title">{{ data.column.caption }}</span>
  </div>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  data() {
    return {
      selectAll: false,
      checkBoxValue: this.value,
    };
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectAllChecked: {
      type: Function,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
    value: {
      // type: Boolean,
      // default: null
    },
    id: {
      type: String,
      default: "select-all",
    },
  },
  methods: {
    selectAllItems(e) {
      this.selectAllChecked(e, this.data);
    },
    onInitialized(e) {
      e.component.beginUpdate();
      e.component.option("value", this.value);
      e.component.endUpdate();
    },
    getSeletcAllRef() {
      return this.$refs["select-all-" + this.data.column.dataField];
    },
  },
  created() {},
  watch: {
    value(val) {
      this.getSeletcAllRef().instance.option("value", val);
    },
  },
};
</script>

<style lang="scss">
.template-header-title {
  /* padding-left: 15px; */
}
</style>
